import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import dayjs from "dayjs";
import {
  useAddBankMutation,
  useDeleteBankMutation,
  useEditBankMutation,
  useGetBanksQuery,
} from "../../../../../redux/Service/BanksApi";
import { useGetCurrenciesQuery } from "../../../../../redux/Service/currenciesApi";
import { useGetAccountsQuery } from "../../../../../redux/Service/Accounts";

function Banks() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const { data: banksData, isLoading: isBanksLoading } =
    useGetBanksQuery(undefined);
  const banks = banksData?.ResponseObject ?? [];

  const { data: currenciesData } = useGetCurrenciesQuery(undefined);
  const currencies = currenciesData?.ResponseObject ?? [];

  const { data: accountsData } = useGetAccountsQuery(undefined);
  const accounts = accountsData?.ResponseObject ?? [];

  const [deleteBank, { isLoading: isDeleting }] = useDeleteBankMutation();
  const [addBank, { isLoading: isAdding }] = useAddBankMutation();
  const [updateBank, { isLoading: isUpdating }] = useEditBankMutation();

  const handleDeletClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف البنك "${record.BankName}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteBank(record.BankID).unwrap();
          if (response?.ResponseObject === true) {
            message.success("تم حذف البنك بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const columns = [
    { title: "اسم البنك", dataIndex: "BankName", key: "BankName" },
    {
      title: "العملة",
      dataIndex: "CurrID",
      key: "CurrID",
      render: (text: any) => {
        const currency = currencies.find((cur: any) => cur.CurrID === text);
        return currency ? currency.CurrName : text;
      },
    },
    {
      title: "الحساب",
      dataIndex: "AccId",
      key: "AccId",
      render: (text: any) => {
        const account = accounts.find((acc: any) => acc.AccID === text);
        return account ? account.AccName : text;
      },
    },
  ];

  const handleOk = async (values: any) => {
    const body = {
      ...values,
      FirstBalDate: values.FirstBalDate?.format("YYYY-MM-DDTHH:mm:ss"),
    };

    try {
      const response = isEditing
        ? await updateBank(body).unwrap()
        : await addBank(body).unwrap();

      if (response?.ResponseObject === true) {
        message.success(
          isEditing ? "تم تعديل البنك بنجاح" : "تمت إضافة البنك بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch {
      message.error("فشل الاتصال بالخادم");
    }
  };

  const resetModal = () => {
    form.resetFields();
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);
    const recordData = {
      ...record,
      FirstBalDate: record.FirstBalDate ? dayjs(record.FirstBalDate) : null,
    };
    setTimeout(() => {
      form.setFieldsValue(recordData);
    }, 0);
  };

  return (
    <div className="flex flex-wrap gap-4 relative">
      <div className="grid justify-start my-2">
        <Button
          type="primary"
          style={{ width: "10rem" }}
          onClick={() => setIsModalOpen(true)}
        >
          إضافة بنك
        </Button>
      </div>

      <FormModal
        form={form}
        isEditing={isEditing}
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        loading={isAdding || isUpdating}
        currencies={currencies}
        accounts={accounts}
      />

      <DataTable
        columns={columns}
        data={banks}
        handleEditClick={handleEditClick}
        handleDeletClick={handleDeletClick}
        isLoading={isBanksLoading || isDeleting}
      />
    </div>
  );
}

export default Banks;
